
import { Title, Meta } from '@angular/platform-browser';
import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { Routes, Event, Router, ActivatedRoute, Params } from '@angular/router';
import { RouteChangeNotifierService } from '../services/route-change-notifier.service';
//import { PostageInfoService } from './services/postage-info-service';
import { Location } from '@angular/common';
import { CloseDropdownService } from '../services/close-dropdown.service';
import { CallAPIService } from '../services/call-api.service';
import { ModalDirective } from 'ngx-bootstrap/modal';



@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.sass'],
	encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {

	public currentPageLabel: string;
	public currentHelpClient: string;
	public isTabsAreHidden: boolean = false;
	public datePostIndex = undefined;

	constructor(
		private router: Router,
		private calculatorRoute: RouteChangeNotifierService,
		//private postageInfoService :PostageInfoService,
		private titleService: Title,
		private metaService: Meta,
		private API: CallAPIService,
    	private activatedRoute: ActivatedRoute,
		private closeDropdown: CloseDropdownService,
		private location: Location) {

		this.titleService.setTitle('Пошук індексів | Укрпошта');
		this.metaService.updateTag({ name: 'description', content: 'Сервіс пошуку індексів і відділень Укрпошти по всій території України.' });
		this.metaService.updateTag({ name: 'keywords', content: 'укрпошта індекси, індекс, поштові індекси, індекси укрпошта, індекси, укрпошта індекс, індекс укрпошта, поштовий індекс, індекси україни, поштові індекси укрпошта, індекс київ, індекси києва, укрпошта індекси, індекс, поштові індекси, індекси укрпошта, індекси, укрпошта індекс, індекс укрпошта, поштовий індекс, індекси україни, поштові індекси укрпошта' });

		this.currentPageLabel = '';

		this.metaService.updateTag({ property: 'og:type', content: 'website' });
		this.metaService.updateTag({ property: 'og:image', content: 'https://index.ukrposhta.ua/assets/og-logo.png' });
		this.metaService.updateTag({ property: 'og:site_name', content: 'Ukrposhta' });


		this.metaService.updateTag({ property: 'og:title', content: 'Пошук індексів | Укрпошта' });
		this.metaService.updateTag({ property: 'og:description', content: 'Сервіс пошуку індексів і відділень Укрпошти по всій території України.' });
		this.metaService.updateTag({ property: 'og:url', content: 'https://index.ukrposhta.ua/find-post-index' });



		this.location.onUrlChange(loc => {

			if (loc.toString().includes('find-address')) {
				this.isTabsAreHidden = false;
				this.currentPageLabel = 'Знайти адресу';
				this.currentHelpClient = '';
				this.activatedRoute.queryParams.subscribe(params => {
			      let datePostIndex = params['postIndex'];
			      if (datePostIndex == undefined){
			      	this.setFindAddressOG()
			      } else {
			      	this.titleService.setTitle('Пошук індексів ' + datePostIndex + ' | Укрпошта');
					this.metaService.updateTag({ name: 'description', content: 'Сервіс пошуку індексів ' + datePostIndex + ' і відділень Укрпошти по всій території України.' });
					this.metaService.updateTag({ name: 'keywords', content: datePostIndex +', укрпошта індекси, індекс, поштові індекси, індекси укрпошта, індекси, укрпошта індекс, індекс укрпошта, поштовий індекс, індекси україни, поштові індекси укрпошта, індекс київ, індекси києва, укрпошта індекси, індекс, поштові індекси, індекси укрпошта, індекси, укрпошта індекс, індекс укрпошта, поштовий індекс, індекси україни, поштові індекси укрпошта' });
			      	this.metaService.updateTag({ property: 'og:title', content: 'Поштові індекси та відділення ' + datePostIndex +' | Укрпошта' });
					this.metaService.updateTag({ property: 'og:description', content: 'Поштові індекси ' + datePostIndex +' та відділення поштового зв’язку України' });
					this.metaService.updateTag({ property: 'og:url', content: 'https://index.ukrposhta.ua/find-address' });
			      }
			    });
				
			}
			if (loc.toString().includes('find-post-index')) {
				this.currentPageLabel = 'Знайти поштовий індекс';
				this.currentHelpClient = 'Заповнюйте назву населеного пункту лише українською без використання цифр (щонайменше 2 літери)';
				this.isTabsAreHidden = false;
				this.setFindIndexOG()
			}
			if (!loc.toString().includes('find-post-index') && !loc.toString().includes('find-address')) {

				this.currentPageLabel = 'Поштові індекси та відділення';
				this.isTabsAreHidden = true;

				this.titleService.setTitle('Поштові індекси та відділення | Укрпошта');
				this.metaService.updateTag({ name: 'description', content: 'Поштові індекси та відділення поштового зв’язку України' });
				this.metaService.updateTag({ name: 'keywords', content: 'укрпошта індекси, індекс, поштові індекси, індекси укрпошта, індекси, укрпошта індекс, індекс укрпошта, поштовий індекс, індекси україни, поштові індекси укрпошта, індекс київ, індекси києва, укрпошта індекси, індекс, поштові індекси, індекси укрпошта, індекси, укрпошта індекс, індекс укрпошта, поштовий індекс, індекси україни, поштові індекси укрпошта' });


				/*this.metaService.updateTag({ name: 'og:title', content: 'Поштові індекси та відділення | Укрпошта' });
				this.metaService.updateTag({ name: 'og:description', content: 'Поштові індекси та відділення поштового зв’язку України' });
				this.metaService.updateTag({ name: 'og:url', content: 'https://index.ukrposhta.ua/find-address' });
				*/

			}
		})

	}

	public changeTab(newAddress: string) {
		let clearConfig = this.API.buildClearConfig(true, true, true, true, true);
		this.API.executeClearWithConfig(clearConfig);
	}

	ngOnInit() {

	}

	@HostListener('document:click', ['$event'])
	clickedOn(event) {

		let classesArray = event.target.classList.value;

		if (!(classesArray.includes('dropButton') || classesArray.includes('fa-caret-down'))) {
			this.closeDropdown.closeAll();
		}

	}

	setFindAddressOG() {
		this.titleService.setTitle('Поштові індекси та відділення | Укрпошта');
		//this.metaService.updateTag({ property: 'og:url', 'www.domain.com/page' });
		this.metaService.updateTag({ property: 'og:title', content: 'Поштові індекси та відділення | Укрпошта' });
		this.metaService.updateTag({ property: 'og:description', content: 'Поштові індекси та відділення поштового зв’язку України' });
		this.metaService.updateTag({ property: 'og:url', content: 'https://index.ukrposhta.ua/find-address' });

	}

	setFindIndexOG() {
		this.titleService.setTitle('Пошук індексів | Укрпошта');
		this.metaService.updateTag({ property: 'og:title', content: 'Пошук індексів | Укрпошта' });
		this.metaService.updateTag({ property: 'og:description', content: 'Сервіс пошуку індексів і відділень Укрпошти по всій території України.' });
		this.metaService.updateTag({ property: 'og:url', content: 'https://index.ukrposhta.ua/find-post-index' });

	}

}
